
  
<div class="not-found-container">
  <div class="not-found-container2">
    <h3 class="not-found-text2">OOPS! USER NOT FOUND</h3>
  </div>
  <div class="not-found-container2">
    <h1 class="not-found-text1" >400</h1>
  </div>
  <div class="not-found-container2">
    <h2 class="not-found-text2">
      WE ARE SORRY, BUT THIS USER DO NOT HAVE A ACCOUNT ON FODE
    </h2>
  </div>

  <div >
    <button (click)="onClick()" class="focus:outline-none hover:bg-gray-800 focus:ring-4 focus:ring-gray-300 w-fit text-white mat-mdc-input-element bg-gray-500 inter-semibold self-stretch px-6 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex dark:hover:bg-red-700 dark:focus:ring-red-900 "
    > Revenir à FODE</button>
  </div>

    
  
  </div>
  